export default __webpack_public_path__ + "static/media/25102401.9bb16e9a.jpg";